import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AdvancedPageRoutingModule } from './advanced-routing.module';
import { AdvancedPage } from './advanced.page';
import { DoctorsListComponent } from '../../components/doctors-list/doctors-list.component';
import { Chooser } from '@awesome-cordova-plugins/chooser/ngx';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    AdvancedPageRoutingModule,
    ImageCropperModule,
  ],
  declarations: [AdvancedPage,DoctorsListComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  providers:[Chooser]

})
export class AdvancedPageModule {}
